import {ITheme, IThemeContent} from '@/themes/theme.interface';
import {Injectable, signal} from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private theme: ITheme | null = null;

  // ✅ Signal para reactivo acceso al logo
  public logoPath = signal<string>('');
  public brandName = signal<string>('');
  public themeContent = signal<IThemeContent | null>(null);

  setTheme(theme: ITheme) {
    this.theme = theme;

    this.logoPath.set(theme.images?.companyLogo?.path ?? '');
    this.brandName.set(theme.name);

    this.themeContent.set(theme.content);

    // Apply CSS custom properties
    this.applyThemeColors(theme.colors);

    // Apply metadata
    this.applyMetadata({
      title: theme.content.global.appName,
      favicon: theme.icons.favicon.path
    });
  }

  private applyThemeColors(colors: ITheme['colors']) {
    const root = document.documentElement;
    Object.entries(colors).forEach(([key, value]) => {
      root.style.setProperty(`--${key}`, value);
    });
  }

  getTheme(): ITheme | null {
    return this.theme;
  }

  getLogo(): string {
    return this.logoPath();
  }

  getBrandName(): string {
    return this.brandName();
  }

  getContent(section?: keyof IThemeContent): any {
    if (!section) return this.themeContent()?.global;

    switch (section) {
      case 'global':
        return this.themeContent()?.global;
      default:
        console.warn(`Sección '${String(section)}' no encontrada en el tema`);
        return null;
    }
  }



  private applyMetadata(meta: {title?: string, favicon?: string}) {
    if (meta.title) document.title = meta.title;
    if (meta.favicon) {
      const link = document.querySelector(
        "link[rel~='icon']"
      ) as HTMLLinkElement | null;
      if (link) link.href = meta.favicon;
    }
  }
}
